import useSharedShowPageContext from '../../common/hooks/useSharedShowPageContext';
import useRelatedShows from '../../common/hooks/useRelatedShows';
import styles from './styles.module.scss';
import ConnectedShowPreviewRow from '@/components/app/ConnectedShowPreviewRow';
import useShow from '@/hooks/shows/useShowFromURL';

const RelatedSection = () => {
  const { show } = useShow();
  const { title: showTitle } = show;
  const { onClickPlayEpisode, onClickRelatedShow } = useSharedShowPageContext();

  const {
    isLoading,
    shows,
    isError,
    refetch
  } = useRelatedShows();
 
  return (
    <ConnectedShowPreviewRow
      channelPreviews={ shows }
      className={ styles.relatedRow }
      description='Hand-picked by our curators'
      disableImpressionEvent
      error={ isError }
      id='related-row'
      isExpandable={ false }
      isLoading={ !showTitle }
      isLoadingShows={ isLoading }
      onClickChannel={ !isLoading ? onClickRelatedShow : undefined }
      onClickPlay={ onClickPlayEpisode }
      onRetry={ refetch }
      title='More shows like this'
    />
  );
};

export default RelatedSection;